import {Spec} from 'immutability-helper';
import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {ClientId} from 'notebook/ELNConstants';
import {PLATE_MAP_PLUGIN_VIRTUALIZED_HEIGHT} from 'notebook/integrations/plate-maps/PlateMapPluginConstants';
import ScratchPlateDesignSummary from 'notebook/integrations/plate-maps/scratch-plates/ScratchPlateDesignSummary';
import MediocrePlugins from 'notebook/mediocre/base-plugin/plugins';
import {MediocreItemAction} from 'notebook/mediocre/EditorTypes';
import {MediocreSearchResultProps} from 'notebook/mediocre/search/SearchResultProps';
import SelectableNotePart from 'notebook/mediocre/selection/block/SelectableNotePart';
import {NoteEditor, NoteEditorPlugin, NoteEditorProps} from 'notebook/notes/NoteEditorTypes';
import {NotePart} from 'notebook/util/NoteUtilConstants';
import {GenericNoteLinkedScratchPlateDesign} from 'notebook/util/NoteUtilConstants';
import notifications from 'notifications';

type NoteLinkedScratchPlateDesign = GenericNoteLinkedScratchPlateDesign<ClientId>;
type ScratchPlateDesignNotePart = NotePart & {item: NoteLinkedScratchPlateDesign};

interface ScratchPlateDesignItemProps {}

const NOTE_LINKED_SCRATCH_PLATE_DESIGN_PLUGIN: NoteEditorPlugin = {
  type: ModelTypeConstants.NOTE_LINKED_SCRATCH_PLATE_DESIGN,
  title: 'Plate Design',
  icon: 'tube-arrow-right',
  linkable: false,
  alignable: false,
  canPasteFromOtherTenant: false,
  component: {
    ...MediocrePlugins.selectablePluginBase,
    required: [],
    getItemProps(this: NoteEditor, _notePart: ScratchPlateDesignNotePart): ScratchPlateDesignItemProps {
      return {};
    },
    make(
      this: NoteEditor,
      notePart: ScratchPlateDesignNotePart,
      index: number,
      editorProps: NoteEditorProps,
      _itemProps: ScratchPlateDesignItemProps,
      _searchResultProps: MediocreSearchResultProps
    ): JSX.Element {
      return (
        <SelectableNotePart indentation={notePart.indentation}>
          <ScratchPlateDesignSummary
            scratchPlateId={notePart.item.data.scratchPlateId}
            locked={editorProps.locked}
            viewer={editorProps.viewer}
            onEdit={(initialState, scratchPlateId, refetch) => {
              this._openScratchPlateDesignEditModal(
                index,
                notePart.item.cid,
                scratchPlateId,
                initialState,
                refetch
              );
            }}
            onFillPlates={(initialDesignState) => {
              this._openFillPlatesModal(index, initialDesignState);
            }}
          />
        </SelectableNotePart>
      );
    },
    getVirtualizedHeight: (_item: ScratchPlateDesignNotePart, _isCollapsed: boolean) =>
      PLATE_MAP_PLUGIN_VIRTUALIZED_HEIGHT,
  },
  itemToText(this: NoteEditor, item: ScratchPlateDesignNotePart): string {
    return item.item.data.scratchPlateName || item.item.data.scratchPlateId;
  },
  itemToHTML(this: NoteEditor, $el: JQuery, _item: ScratchPlateDesignNotePart): JQuery {
    return $el;
  },
  itemFromHTML(this: NoteEditor, _$el: JQuery, _item: ScratchPlateDesignNotePart): null {
    // TODO(BNCH-154434): Support copy/paste by duplicating the underlying ScratchPlate and returning a note
    // part linked to the new DB object
    notifications.warn('Non-registry plate designs cannot be pasted.');
    return null;
  },
  getContent(this: NoteEditor, {item}: ScratchPlateDesignNotePart): {item: NoteLinkedScratchPlateDesign} {
    return {item};
  },
  setContent(this: NoteEditor, _data: unknown): Spec<NotePart> {
    throw new Error('Cannot set content for non-registry plate designs.');
  },
  getReasonForDisallowedAction(
    this: NoteEditor,
    _item: ScratchPlateDesignNotePart,
    _action: MediocreItemAction
  ): string | null {
    return null;
  },
};

export default NOTE_LINKED_SCRATCH_PLATE_DESIGN_PLUGIN;
